/* eslint-disable no-underscore-dangle */
import { throwOnError } from './utils';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
    current: number;
  };
};

type GetBalancesResponse = Paginated<{
  expires_at: string;
  money_amount: number | null;
  point_amount: number | null;
}>;

export const updateAccount = (id: string, postData: Record<string, unknown>) =>
  fetch(`/api/accounts/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
  }).then(throwOnError);

export const deleteAccount = (id: string, postData: Record<string, unknown> = {}) =>
  fetch(`/api/accounts/${id}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
  }).then(throwOnError);

export const updateAccountAttribute = (accountId: string, postData: { external_id?: string }) =>
  fetch(`/api/accounts/${accountId}/customers`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
  }).then(throwOnError);

export const getAccountBalances = (accountId: string, query = '') =>
  fetch(`/api/accounts/${accountId}/balances?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then(throwOnError<GetBalancesResponse>);

export const getAccountExpiredBalances = (accountId: string, query = '') =>
  fetch(`/api/accounts/${accountId}/expired-balances?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then(throwOnError<GetBalancesResponse>);

export type DebtRow = {
  point_amount: number;
  bear_point_shop_name: string;
  bear_point_shop_account_id: string;
  bear_point_shop_id: string;
  shop_organization_name: string;
  shop_organization_code: string;
  created_at: string;
  updated_at: string;
};

export type GetAccountDebtResponse = {
  per_page: number;
  count: number;
  prev: string | null;
  next: string | null;
  rows: DebtRow[];
};

export const getAccountDebt = (accountId: string, query = '') =>
  fetch(`/api/accounts/${accountId}/debts?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
  }).then(throwOnError<GetAccountDebtResponse>);
